if (document.querySelector('.open_filter_cls')) {
  document.querySelector('.open_filter_cls').addEventListener('click', function() {
    this.classList.toggle('filter_active');
    document.getElementById('FacetsWrapperDesktop').classList.toggle('dd_cm_filter');
    document.querySelector('[aria-labelledby="verticalTitle"]').classList.toggle('dd_filter');
    document.querySelector('[collection-grid-class]').classList.toggle('custom_grid_class');
    if (document.querySelector('[collection-grid-class]').classList.contains('grid--4-col-desktop')) {
      document.querySelector('[collection-grid-class]').classList.remove('grid--4-col-desktop')
      document.querySelector('[collection-grid-class]').classList.add('grid--3-col-desktop');
    } else if (document.querySelector('[collection-grid-class]').classList.contains('grid--3-col-desktop')) {
      document.querySelector('[collection-grid-class]').classList.remove('grid--3-col-desktop')
      document.querySelector('[collection-grid-class]').classList.add('grid--4-col-desktop');
    }
  });
}

/*==== menu hover Js ======*/


if (window.innerWidth >= 1440) {
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      // var isAttr = item.getAttribute('custom_mega_menu');
      // if (!isAttr) {
      //   headerSelector.classList.add('men-bg-menu');
      //   document.body.classList.add('men-bg-menu-color');
      // }
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        // if (headerSelector.classList.contains('men-bg-menu')) {
        //   headerSelector.classList.remove('men-bg-menu');
        // }
      });
    });
  });

  var headerSelector = document.querySelector('sticky-header');
  let items_menu = document.querySelector(".header__inline-menu").querySelectorAll("li");
    items_menu.forEach(item => {
    item.addEventListener("mouseover", () => {
      var isAttr = item.getAttribute('custom_mega_menu');
      if (document.body.classList.contains('men-bg-menu-color')) {
        if (isAttr == 'false') {
          headerSelector.classList.add('men-bg-menu');
        }
      }else{
        if (isAttr == 'true') {
          headerSelector.classList.add('men-bg-menu');          
        }
      }
      item.addEventListener("mouseleave", () => {
        if (headerSelector.classList.contains('men-bg-menu')) {
          headerSelector.classList.remove('men-bg-menu');
        }
      });
    });
  });  
}

/*====menu hover Js======*/

// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end
(function() {
  faq_taggol();

})();


// hotsport start
function hosport_click(item) {
  item.addEventListener("click", (event) => {
    event.stopPropagation(); // Prevent body click event from firing immediately
    
    let hide_content = document.querySelectorAll("[data-host-port-content]");
    let targetSelector = event.target.getAttribute('data-hotsport-click');
    let targetContent = document.querySelector(targetSelector);

    if (targetContent) {
      if (targetContent.classList.contains('hidden')) {
        // Hide all other content
        hide_content.forEach(b => b.classList.add("hidden"));
        
        // Show the clicked content
        targetContent.classList.remove("hidden");
        targetContent.classList.add("show_spot");
        document.body.classList.add('overflow_hidden');
      } else {
        // Hide current content
        targetContent.classList.add("hidden");
        targetContent.classList.remove("show_spot");
        document.body.classList.remove('overflow_hidden');
      }
    }
  });
}

// Attach event to all elements with [data-hotsport-click]
document.querySelectorAll("[data-hotsport-click]").forEach(hosport_click);

// Body click to close content when clicking outside
document.body.addEventListener("click", (event) => {
  if (document.body.classList.contains("overflow_hidden")) {
    // Ignore clicks inside the currently open content
    if (!event.target.closest('.show_spot[data-host-port-content]')) {
      console.log("Closing content");

      document.querySelector('.show_spot[data-host-port-content]')?.classList.add("hidden");
      document.querySelector('.show_spot[data-host-port-content]')?.classList.remove("show_spot");
      document.body.classList.remove('overflow_hidden');
    }
  }
});


// hotsport end


//megamenu hover
// document.querySelectorAll('.custom_main_link').forEach(function(link) {
//   link.addEventListener('mouseenter', function() {
//     var dataTitle = this.getAttribute('data_title');
//     var parent = this.closest('.custom_mega_menu_header');
//     document.querySelectorAll('.custom_main_link').forEach(function(link) {
//         link.classList.remove('active');
//     });
//     this.classList.add('active');
//     document.querySelectorAll('.custom_mega-penal').forEach(function(panel) {
//         panel.classList.add('hidden');
//     });
//     if (document.querySelector('.custom_mega-penal.hidden[data_title="' + dataTitle + '"]')) {
//       document.querySelectorAll('.custom_mega-penal[data_title="' + dataTitle + '"]').forEach(function(item) {
//         item.classList.remove('hidden');
//       });
//     }
//   });
// });


document.querySelectorAll('.custom_main_link').forEach(function(link) {
  link.addEventListener('mouseenter', function() {
    var dataTitle = this.getAttribute('data_title');
    var parent = this.closest('.custom_mega_menu_header');

    // Remove active from links inside this header only
    parent.querySelectorAll('.custom_main_link').forEach(function(innerLink) {
      innerLink.classList.remove('active');
    });
    this.classList.add('active');

    // Hide all panels inside this header
    parent.querySelectorAll('.custom_mega-penal').forEach(function(panel) {
      panel.classList.add('hidden');
    });

    // Show matching panel inside this header
    parent.querySelectorAll('.custom_mega-penal[data_title="' + dataTitle + '"]').forEach(function(item) {
      item.classList.remove('hidden');
    });
  });
});


// PASSWORD SHOW AND HIDE start

class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    event.preventDefault();
    this.closest('.field').querySelector('input').setAttribute('type', this.closest('.field').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

 // <show-password>
 //   <a href="javascript:void(0);"class="close-icon">text</a>
 // </show-password>

customElements.define('show-password', ShowPassword);

// PASSWORD SHOW AND HIDE END

// Blog Page Tag Filter Button Slider JS
let articleSwiper = null;

function initArticleSwiper() {
  if (window.innerWidth < 750 && !articleSwiper) {
    articleSwiper = new Swiper('.cm_mobile_blog_slider', {
      slidesPerView: 3,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: { slidesPerView: 2 },
        450: { slidesPerView: 2 },
        749: { slidesPerView: 3 }
      }
    });
  } else if (window.innerWidth >= 750 && articleSwiper) {
    articleSwiper.destroy(true, true);
    articleSwiper = null;
  }
}

// Run on load
initArticleSwiper();

// Run on resize
window.addEventListener('resize', () => {
  initArticleSwiper();
});

// Book appointment page
if (document.body.classList.contains('template-termin-buchen')) {
  const book_appoint_buttons = document.querySelectorAll('[book_appoint_button]');
  if (book_appoint_buttons.length > 0) {
     book_appoint_buttons.forEach(button => {
      const step_number = button.getAttribute('data-step_number');
      const type_data = button.getAttribute('data-type_data');
       button.addEventListener("click", () => {
         console.log("type_data",type_data)
         console.log("step_number" , step_number)
         document.querySelectorAll('[appointment_page]').forEach(item => {
           item.classList.add('hidden');
         });
         const showDivs = document.querySelectorAll('[data-step_number="'+ step_number +'"][data-type_data="'+ type_data +'"]');
         console.log("showDivs",showDivs)
         window.scrollTo({ top: 0, behavior: 'smooth' });
         showDivs.forEach(div => {
           div.classList.remove('hidden');
         });
       });
    }); 
  }
}


